export default "__VITE_ASSET__b1ec7113__"